import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const a = r((l, i) => /* @__PURE__ */ s.jsx(
  c,
  {
    ref: i,
    ...l,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...e,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4141)", children: [
            /* @__PURE__ */ s.jsx(
              "mask",
              {
                id: "mask0_2974_4141",
                width: 34,
                height: 32,
                x: 7,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M39.76 38.7c-5.21-4.9-14.05-5.15-15.76-5.15-5.94 0-11.67 1.86-15.72 5.11-.32.26-.38.73-.12 1.05.15.2.37.29.59.29.16 0 .33-.05.47-.17 3.79-3.04 9.17-4.78 14.78-4.78 1.62 0 9.93.23 14.74 4.74.3.28.78.27 1.06-.03s.27-.77-.04-1.06M24 32.12c.41 0 .75-.34.75-.75V9.5h12.69l-3.12 3.12c-.29.29-.29.77 0 1.06l3.12 3.12h-10.7c-.41 0-.75.34-.75.75s.34.75.75.75h12.51c.3 0 .58-.18.69-.46.12-.28.05-.6-.16-.82l-3.88-3.87 3.87-3.87c.21-.21.28-.54.16-.82a.73.73 0 0 0-.68-.46H24c-.41 0-.75.34-.75.75v22.62c0 .41.34.75.75.75"
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4141)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4141", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
a.displayName = "AgencyFirmnessFlagIcon";
export {
  a as AgencyFirmnessFlagIcon,
  a as default
};
//# sourceMappingURL=index.js.map
